import { html, PropertyValues, TemplateResult } from 'lit';
import {
  API_TYPE_NIRVANA, WEB_COMPONENT_EXECUTIVE_SUMMARY_OVERVIEW,
} from '../../../../webcomponents.constants';
import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { customElement, property, query } from 'lit/decorators.js';
import { GetWidgetDataRequest } from '../../../../types/widget/types';
import { Observable, of } from 'rxjs';
import {
  GetOverviewInformationResponse, OverviewPayload,
} from '@nirvana/shared/dtos/types/widgets/common';
import { translateFn } from '../../../../utils/translator.helper';
import { getTimezone } from '../../../../utils/global.utils';
import { OverviewWebComponent } from '../../../../overview';
import { getDisplayMode, sanitizeReportingPeriod } from '../../../utils/utils';

@customElement(WEB_COMPONENT_EXECUTIVE_SUMMARY_OVERVIEW)
export class GzOverviewWebComponent extends GzGenericWidgetContent {
  @property({ type: Object, attribute: true, reflect: true })
  payload: OverviewPayload;

  @query('#gzOverview')
  private overview: OverviewWebComponent;

  injectDependencies(dependencies: any) {
    this.dependencies = dependencies;
  }

  getPayload() {
    return this.payload;
  }

  updated(_changedProperties: PropertyValues): void {
    super.updated(_changedProperties);

    const dependencies = {
      Ext: this.dependencies ? this.dependencies.Ext : undefined,
      getTimezone: getTimezone,
      getUserLanguage: Application.Main.getLanguage,
      translateFn: translateFn,
      api: {
        type: API_TYPE_NIRVANA,
        clients: {
          Widgets: {
            getOverviewInformation: function (request: GetWidgetDataRequest): Observable<GetOverviewInformationResponse> {
              return of(this.getPayload().overviewInformation);
            }.bind(this)
          }
        }
      }
    };

    if (this.overview) {
      if (!this.overview.started) {
        this.overview.injectDependencies(dependencies);
        this.overview.start();
      } else {
        this.overview.controller?.render();
      }
    }
  }

  protected renderContent(): TemplateResult {
    return html `
      <gz-overview id="gzOverview"
                   data-reporting-period=${JSON.stringify(sanitizeReportingPeriod(this.payload?.reportingPeriod))}
                   data-targets=${JSON.stringify(this.payload?.targets)}
                   data-can-drill-down=${true}
                   data-display-mode=${getDisplayMode()}
      ></gz-overview>`;
  }
}
